import { Injectable } from '@angular/core'
import { AngularFireAuth } from '@angular/fire/auth'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore'
import { of as observableOf, from as observableFrom, Observable, of } from 'rxjs';
import { map, switchMap, take, tap, first } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { UUID } from 'angular2-uuid';
import Web3 from 'web3';
declare let window: any;
declare const BigInt: typeof Number;

@Injectable({
	providedIn: 'root',
})
export class DataService {
	currentUser: any
	path: string = '';

	public strCookie = 'cryptoaz_currentUser';

	bApproved;

	invitecode;
	inviteaddress;owneraddress;

	tableusers = "cryptoaz_users"
	tableregister = "cryptoaz_registration"
	tableinvitestemp = "cryptoaz_invites_temp"
	tableinvites = "cryptoaz_invites"
	tablebuy = "cryptoaz_buy"
	tablemsg = "cryptoaz_messages"

	public loaded; public status; public networkid; public type;
	public coinbase; web3Provider; public web3; //Web3Modal;
	public userRegistered; public userEmail; public userInfo;
	public tokenContract;
	public contractBusd; public contractUsdt; public contractUsdc;
	public tokenAddress; public tokenAbi;
	public struser: any = {};

	public bwallet=1; public bnetwork=0; public bbalance=0; public bapprove=0;

	constructor(
		private angularFireAuth: AngularFireAuth, 
		private afStore: AngularFirestore,
		private httpClient: HttpClient) {

		this.inviteaddress=this.owneraddress=environment.ownerAddress;

		this.angularFireAuth.authState.subscribe((user) => {
			if (user) {
				this.currentUser = user
			}
		})
	}

	getList(entity: string): Observable<any[]> {
		const ref = this.afStore.collection(entity)
		return ref.valueChanges()
	}
	getByID(table, id) {
		const ref = this.afStore.collection(table);
		let item = ref.doc(id) as AngularFirestoreDocument<any>;
		return observableFrom(item.valueChanges()).pipe(
			tap((rs) => console.log('get item: ')));
	}


	getSubList(entity: string, id: string, subentity: string): Observable<any[]> {
		const ref = this.afStore.collection(`${entity}/${id}/${subentity}`)
		return ref.valueChanges().pipe(take(1))
	}

	getItemByID(entity: string, id: any): Observable<any> {
		const ref = this.afStore.collection(entity).doc(id)
		return ref.valueChanges().pipe(take(1))
	}

	saveItem(entity: string, item: any) {
		if (!item.id) item.id = UUID.UUID();

		const itemRef: AngularFirestoreDocument<any> = this.afStore.doc(`${entity}/${item.id}`)
		return itemRef.set(item, { merge: true })
	}

	saveSubItem(entity: string, id: string, subentity: string, item: any) {
		if (!item.id) item.id = UUID.UUID()

		const itemRef: AngularFirestoreDocument<any> = this.afStore.doc(`${entity}/${id}/${subentity}/${item.id}`)
		return itemRef.set(item, { merge: true })
	}

	saveItemById(entity: string, item: any, id: any) {
		if (id) {
			const itemRef: AngularFirestoreDocument<any> = this.afStore.doc(`${entity}/${id}`)
			return itemRef.set(item, { merge: true })
		}

		return of(null).toPromise()
	}

	async deleteItem(entity: string, uid: any) {
		// const itemRef: AngularFirestoreDocument<any> = this.afStore.doc(`${entity}/${uid}`);
		// await itemRef.delete();
		return this.afStore.collection(entity).doc(uid).delete()
	}

	get timestamp() {
		return new Date()
	}


	sortField(list, field, type = 'asc') {
		if (type == 'asc') {
			return list.sort((a: any, b: any) => {
				if (!a[field])
				a[field] = 0;

				if (!a[field])
				b[field] = 0;

				if (a[field] < b[field]) {
					return -1;
				} else if (a[field] > b[field]) {
					return 1;
				} else {
					return 0;
				}
			});
		}
		else {
			return list.sort((a: any, b: any) => {
				if (!a[field])
				a[field] = 0;

				if (!a[field])
				b[field] = 0;

				if (a[field] > b[field]) {
					return -1;
				} else if (a[field] < b[field]) {
					return 1;
				} else {
					return 0;
				}
			});
		}
	}

	sortDate(list, type = 'asc') {
		if (type == 'asc') {
			return list.sort((a: any, b: any) => {
				if (a['date'] < b['date']) {
					return -1;
				} else if (a['date'] > b['date']) {
					return 1;
				} else {
					return 0;
				}
			});
		}
		else {
			return list.sort((a: any, b: any) => {
				if (a['date'] > b['date']) {
					return -1;
				} else if (a['date'] < b['date']) {
					return 1;
				} else {
					return 0;
				}
			});
		}
	}

	async initweb3() {
		let self = this;
		this.status = "Connecting wallet..."

		try{
		// if (!this.isMobileCheck() || true) {
			if (typeof window.ethereum !== 'undefined') {

				console.log('Injected', window.ethereum);
				//alert(JSON.stringify(window.ethereum))

				this.web3Provider = window.ethereum;
				this.web3 = new Web3(window.ethereum);
				//this.Web3Modal = window.Web3Modal.default;

				this.networkid = window.ethereum.networkVersion;

				this.tokenAddress = environment.contract.addressbsc;
				this.tokenContract = new this.web3.eth.Contract(
					environment.contract.abibsc,
					environment.contract.addressbsc
				);

				this.contractBusd = new this.web3.eth.Contract(
					environment.contractBusd.abi,
					environment.contractBusd.address
				);

				this.contractUsdt = new this.web3.eth.Contract(
					environment.contractUsdt.abi,
					environment.contractUsdt.address
				);

				this.contractUsdc = new this.web3.eth.Contract(
					environment.contractUsdc.abi,
					environment.contractUsdc.address
				);

				window.ethereum.on('accountsChanged', function (accounts) {
					console.log('accountsChanges',accounts);
				 });
			  
				window.ethereum.on('networkChanged', function(networkId){
					console.log('networkChanged',networkId);
					self.networkid = networkId;
					self.networkok();
				});

				try {
					let data = await this.web3Provider.request({ method: 'eth_requestAccounts' })
						.then(async (data) => {
							this.status = "Connected";

							if (data && data.length > 0) {
								this.coinbase = data[0];
								this.userRegistered = true;
							}
						})
						.catch((error) => {
							if (error.code === 4001) {
								// EIP-1193 userRejectedRequest error
								console.log('Please connect to MetaMask.');
								this.status = 'Please connect to MetaMask';
							} else {
								console.error(error);
								//alert(JSON.stringify(error))
								this.status = 'Error: ' + error
							}
						});

						this.afterinit();
				}
				catch (ex) {
					this.status = "Not Connected"
				}

				this.loaded = true;
			}
			else {
				this.loaded = true;
				this.status = "No MetaMask found"
				alert('No MetaMask found!');
			}

		//}
		}
		catch(ex){
			//console.log(JSON.stringify(ex))
		}

	}

	afterinit() {
		let item_ = { id: 1, type: this.type, address: this.coinbase, network: this.networkid, registered: this.userRegistered }
		this.setCookieItem(item_);
		this.getLocalStorage();
	}

	async setnetworkinit(newid = '97') {

		if (newid !== this.networkid) {
			try {
				await this.web3Provider.request({
					method: 'wallet_switchEthereumChain',
					params: [{ chainId: this.web3.utils.toHex(newid) }],
				})
					.then(async (data) => {
						//alert('change chain');
						this.networkid = newid;
					})

			} catch (switchError) {
				// This error code indicates that the chain has not been added to MetaMask.
				if (switchError.code === 4902) {
					//alert('add this chain id')
				}
			}
		}

	}

	setCookieItem(item) {
		//this.deleteCookieItem();

		localStorage.setItem(this.strCookie, JSON.stringify(item));
		//1 day, 0.041 hour 6.83/1e4 min
		//this.cookieService.set('becombee_currentUsertemp', JSON.stringify(item));
		//this.cookieService.set(this.strCookie, '-', 0.041);
	}
	deleteCookieItem() {
		localStorage.removeItem(this.strCookie);
		//this.cookieService.set(this.strCookie, '', 0.00041);
		this.struser = {}
	}
	getLocalStorage() {
		//let temp_ = this.cookieService.get(this.strCookie);
		let temp_ = localStorage.getItem(this.strCookie);

		if (temp_ == "-")
			temp_ = localStorage.getItem(this.strCookie) || '';

		if (temp_) {
			let item_ = temp_ || ""
			if (item_ == "")
				this.struser = {}
			else
				this.struser = JSON.parse(item_);

			if (this.struser.type)
				this.type = this.struser.type;
			else {
				this.type = 1;
				let item_ = { id: 1, type: this.type, address: this.coinbase, network: this.networkid, registered: this.userRegistered }
				this.setCookieItem(item_);
			}
		}
		else {
			this.struser = {}
		}
	}

	async approve() {
	  
		if (!this.contractBusd) {
		  alert("Not contract");
		  return;
		}
	  
		// if (document.getElementById('lblapprove'))
		// document.getElementById('lblapprove').style.display = 'block'
	  
		// let allow = await this.userRegistered.methods.atoken(this.coinbase, environment.contractBusd.address).call();
		// if (allow > 0) {
		//   this.bApproved = true;
	  
		//   if (document.getElementById('lblapprove'))
		//   document.getElementById('lblapprove').style.display = 'none'
	  
		//   //instance();
		//   return;
		// }
	  
		await this.contractBusd.methods.approve(environment.contract.addressbsc, BigInt(1.157920892373162e+59))
		  .send({ from: this.coinbase })
		  .on("receipt", async () => {
			console.log(`You've received the NFT with ID:`);
			this.bApproved = true;
			//instance();
	
		  })
		  .on("error", (error) => {
			console.log(`Error approve!`);
		  })
	  }

	  networkok() {
		let resultok = true;
		resultok = (parseInt(this.networkid) == parseInt(environment.chain));

		// alert(resultok);
		// alert(parseInt(this.networkid));
		// alert(parseInt(environment.chain));

		if (!resultok)
			//alert('Select network Test Samrt chain !');

			this.web3Provider.request({
				method: 'wallet_switchEthereumChain',
				  params: [{ chainId: this.web3.utils.toHex(environment.chain) }],
			})
			.then(async (data) => {
				//alert('change chain')
			})
		

			// if (confirm("Confirm set 'Test Smart Chain'")){
			// 	let newid = environment.chain;
			// 	try {
			// 		await this.web3Provider.request({
			// 		  method: 'wallet_switchEthereumChain',
			// 			params: [{ chainId: this.web3.utils.toHex(newid) }],
			// 		  })
			// 		  .then(async (data) => {
			// 		  		alert('change chain')
			// 		   })
			  
			// 		} catch (switchError) {
			// 		}
			// }

			// return resultok;

		return resultok;
	}

	public apibinance(url): Observable<any> {
        return this.httpClient.get<any>(`${url}`).
          pipe(
            tap((item: any) => {})
          );
      }

	isMobileCheck() {
		let check = false;
		(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
		return check;
	};

	userExist(){
		//return this.tokenContract.methods.isUserExists(this.coinbase).call();

		return new Promise((resolve, reject) => {

			this.getByID(this.tableusers, this.coinbase).subscribe(async (data) => {
				if (data && data['email'])
				resolve(true);
				else
				resolve(false);
			})
	  
		  });
	}
}
